import { useLanguageContext } from "../../../context/LanguageContext";
import PortalPage from "../../../pages/portal/PortalPage";
import { usePortalRouteValidator } from "../../validators/PortalRouteValidator";
import { RouteConfig } from "../RouteConfig";

/**
 * The route config for the visitor portal page
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePortalRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/portal")
    .setLabel(translate("eva.main.entities.visitor_portal_link"))
    .setValidator(usePortalRouteValidator())
    .setPage(<PortalPage />);
}

export default usePortalRouteConfig;
